(function () {
  'use strict';

  function init(container) {
    var grids = container.querySelectorAll('.wb-ugc-grid');

    grids.forEach(function (grid) {
      initGrid(grid);
    });
  }

  function initGrid(grid) {
    if (grid.dataset.wbugInitialized === 'true') return;

    grid.dataset.wbugInitialized = 'true';

    var autoplay = grid.querySelector('[data-wbug-autoplay]');
    var soundBtn = grid.querySelector('[data-wbug-sound]');
    var lightbox = grid.querySelector('[data-wbug-lightbox]');
    var backdrop = grid.querySelector('[data-wbug-backdrop]');
    var closeBtn = grid.querySelector('[data-wbug-close]');
    var lightboxVideo = grid.querySelector('[data-wbug-lv]');
    var playBtns = grid.querySelectorAll('[data-wbug-play]');

    if (autoplay) {
      var playPromise = autoplay.play();

      if (playPromise !== undefined) {
        playPromise.catch(function () {});
      }
    }

    if (soundBtn && autoplay) {
      soundBtn.addEventListener('click', function () {
        var isMuted = autoplay.muted;

        autoplay.muted = !isMuted;
        soundBtn.classList.toggle('is-on', isMuted);
      });
    }

    playBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('[data-wbug-item]');

        if (!item || !lightboxVideo || !lightbox) return;

        var sourcesEl = item.querySelector('[data-wbug-sources]');
        if (!sourcesEl) return;

        var sources = sourcesEl.querySelectorAll('[data-src]');
        var posterEl = sourcesEl.querySelector('[data-poster]');

        lightboxVideo.innerHTML = '';
        lightboxVideo.removeAttribute('poster');

        if (posterEl) {
          lightboxVideo.poster = posterEl.getAttribute('data-poster');
        }

        sources.forEach(function (sourceEl) {
          var source = document.createElement('source');

          source.src = sourceEl.getAttribute('data-src');
          source.type = sourceEl.getAttribute('data-type');

          lightboxVideo.appendChild(source);
        });

        if (autoplay) {
          autoplay.pause();
        }

        lightboxVideo.load();

        var playPromise = lightboxVideo.play();

        if (playPromise !== undefined) {
          playPromise.catch(function () {});
        }

        lightbox.classList.add('is-open');
        lightbox.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      });
    });

    function closeLightbox() {
      if (!lightbox || !lightboxVideo) return;

      lightboxVideo.pause();
      lightboxVideo.innerHTML = '';
      lightboxVideo.removeAttribute('poster');
      lightbox.classList.remove('is-open');
      lightbox.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';

      if (autoplay) {
        var playPromise = autoplay.play();

        if (playPromise !== undefined) {
          playPromise.catch(function () {});
        }
      }
    }

    if (closeBtn) {
      closeBtn.addEventListener('click', closeLightbox);
    }

    if (backdrop) {
      backdrop.addEventListener('click', closeLightbox);
    }

    grid.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && lightbox && lightbox.classList.contains('is-open')) {
        closeLightbox();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && lightbox && lightbox.classList.contains('is-open')) {
        closeLightbox();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();